import { Snackbar, Alert, CircularProgress } from '@mui/material';
import { useUploadStore } from '@/store/uploadStore';

export function ProcessingToast() {
  const uploads = useUploadStore((state) => state.uploads);

  const processingCount = Array.from(uploads.values()).filter(
    (u) => u.status === 'uploading' || u.status === 'processing'
  ).length;

  if (processingCount === 0) {
    return null;
  }

  const message =
    processingCount === 1
      ? '1 receipt processing'
      : `${processingCount} receipts processing`;

  return (
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ mb: 1 }}
    >
      <Alert
        severity="info"
        variant="filled"
        icon={<CircularProgress size={20} color="inherit" />}
        sx={{ minWidth: 250 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
